import { Flex } from 'dash-ui';
import styled from 'styled-components';

export const IconWrapper = styled(Flex)`
  border-radius: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  left: 50%;
  top: 50%;
  transform: translate(-30%, -50%);
  cursor: pointer;
`;
